import { createFileRoute } from "@tanstack/react-router";
import { CursosList } from "@/components/cursos-list";

export const Route = createFileRoute("/cursos/empresas/programas-a-medida")({
  head: () => ({
    meta: [
      { title: "Cursos para Empresas Mineras | Capacitación Empresas | Mine Class" },
      {
        name: "description",
        content:
          "Catálogo de cursos para empresas mineras: seguridad, operación y normativa, con contenidos técnicos adaptados y relatores destacados.",
      },
      { property: "og:title", content: "Cursos para Empresas Mineras | Capacitación Empresas | Mine Class" },
      { property: "og:description", content: "Catálogo de cursos para empresas mineras con contenidos técnicos y relatores destacados." },
      { property: "og:url", content: "https://mine-class.com/cursos/empresas/programas-a-medida" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/cursos/empresas/programas-a-medida" }],
  }),
  component: ProgramasContent,
});

function ProgramasContent() {
  return (
    <div className="space-y-6">
      <div>
        <span className="text-[10px] uppercase tracking-widest font-bold text-[var(--color-brand-coral)]">
          Campus virtuales corporativos
        </span>
        <h2 className="text-2xl md:text-3xl font-bold text-[var(--color-brand-purple)] mt-1">
          Cursos para Empresas
        </h2>
        <p className="text-[var(--color-on-surface-variant)] mt-3 text-base md:text-lg leading-relaxed">
          Somos expertos en capacitación online corporativa. Cursos de alto nivel técnico, adaptados a
          solicitud de las compañías, con los relatores más destacados de la industria.
        </p>
      </div>

      <CursosList type="empresa" />
    </div>
  );
}
